import { render } from "./agregarClinica.vue?vue&type=template&id=ec71be56&scoped=true"
import script from "./agregarClinica.vue?vue&type=script&lang=js"
export * from "./agregarClinica.vue?vue&type=script&lang=js"

import "./agregarClinica.vue?vue&type=style&index=0&id=ec71be56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec71be56"]])

export default __exports__